import React from 'react';
import { Link } from 'react-router-dom';
import './appointments.css';

export default function AppointmentButton({ providerId, providerName, eventId, eventName, source = 'provider', contextId }) {
  if (!Number.isSafeInteger(Number(providerId)) || Number(providerId) <= 0) return null;
  const query = new URLSearchParams({ providerName: providerName || 'Provider', source });
  if (eventId) query.set('eventId', eventId);
  if (eventName?.trim()) query.set('eventName', eventName.trim());
  if (contextId) query.set('contextId', contextId);
  return <Link className="appointment-cta" onClick={e => e.stopPropagation()} to={`/appointments/book/${providerId}?${query}`}>Book an Appointment</Link>;
}
